//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const IdpUserAutoMerge: FeatureFlag = {"Id":"IdpUserAutoMerge","Label":"[10.18]Auto-merge users across IdPs","Impact":"Automatically merge users during SSO login when a configured IdP migration mapping matches by email.","Mode":1,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
